/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface TotalEmissionEstimate
 */
export interface TotalEmissionEstimate {
    /**
     *
     * @type {string}
     * @memberof TotalEmissionEstimate
     */
    deviceGroupTag?: string;
    /**
     *
     * @type {string}
     * @memberof TotalEmissionEstimate
     */
    stateCode?: string;
    /**
     *
     * @type {string}
     * @memberof TotalEmissionEstimate
     */
    countryCode?: string;
    /**
     *
     * @type {number}
     * @memberof TotalEmissionEstimate
     */
    cO2PerWh?: number;
    /**
     *
     * @type {number}
     * @memberof TotalEmissionEstimate
     */
    consumptionWh?: number;
    /**
     * Total estimated CO₂ emissions (kg), aggregated across all emission scopes.
     * @type {number}
     * @memberof TotalEmissionEstimate
     */
    emissionKg?: number;
    /**
     * Percentage difference in emissions (based on EmissionKg) from the previous period, can be null if previous period does not have data.
     * @type {number}
     * @memberof TotalEmissionEstimate
     */
    diffPercentage?: number;
    /**
     *
     * @type {number}
     * @memberof TotalEmissionEstimate
     */
    scope1EmissionKg?: number;
    /**
     *
     * @type {number}
     * @memberof TotalEmissionEstimate
     */
    scope2EmissionKg?: number;
    /**
     *
     * @type {number}
     * @memberof TotalEmissionEstimate
     */
    scope3EmissionKg?: number;
}

/**
 * Check if a given object implements the TotalEmissionEstimate interface.
 */
export function instanceOfTotalEmissionEstimate(
    value: object,
): value is TotalEmissionEstimate {
    return true;
}

export function TotalEmissionEstimateFromJSON(
    json: any,
): TotalEmissionEstimate {
    return TotalEmissionEstimateFromJSONTyped(json, false);
}

export function TotalEmissionEstimateFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): TotalEmissionEstimate {
    if (json == null) {
        return json;
    }
    return {
        deviceGroupTag:
            json["deviceGroupTag"] == null ? undefined : json["deviceGroupTag"],
        stateCode: json["stateCode"] == null ? undefined : json["stateCode"],
        countryCode:
            json["countryCode"] == null ? undefined : json["countryCode"],
        cO2PerWh: json["cO2PerWh"] == null ? undefined : json["cO2PerWh"],
        consumptionWh:
            json["consumptionWh"] == null ? undefined : json["consumptionWh"],
        emissionKg: json["emissionKg"] == null ? undefined : json["emissionKg"],
        diffPercentage:
            json["diffPercentage"] == null ? undefined : json["diffPercentage"],
        scope1EmissionKg:
            json["scope1EmissionKg"] == null
                ? undefined
                : json["scope1EmissionKg"],
        scope2EmissionKg:
            json["scope2EmissionKg"] == null
                ? undefined
                : json["scope2EmissionKg"],
        scope3EmissionKg:
            json["scope3EmissionKg"] == null
                ? undefined
                : json["scope3EmissionKg"],
    };
}

export function TotalEmissionEstimateToJSON(
    value?: TotalEmissionEstimate | null,
): any {
    if (value == null) {
        return value;
    }
    return {
        deviceGroupTag: value["deviceGroupTag"],
        stateCode: value["stateCode"],
        countryCode: value["countryCode"],
        cO2PerWh: value["cO2PerWh"],
        consumptionWh: value["consumptionWh"],
        emissionKg: value["emissionKg"],
        diffPercentage: value["diffPercentage"],
        scope1EmissionKg: value["scope1EmissionKg"],
        scope2EmissionKg: value["scope2EmissionKg"],
        scope3EmissionKg: value["scope3EmissionKg"],
    };
}
